import React, {Dispatch, SetStateAction} from 'react';

import {FlatButton} from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';
import {useShown} from '@pb/kit-hooks-use-shown';

import {
    REMOVE_ENTITLEMENT_TOOL_MODAL_WIDTH,
    RemoveEntitlementToolModal,
} from './remove-entitlement-tool-modal';

import type {PresetRelationItem} from 'src/openapi/admin/models/PresetRelationItem';

type Props = {
    selectedRecords: string[],
    onChange: Dispatch<SetStateAction<PresetRelationItem[]>>,
};

export const RemoveEntitlementTool = (props: Props) => {
    const {selectedRecords, onChange} = props;
    const {shown, onClick, onClose} = useShown();

    return (
        <>
            <FlatButton onClick={onClick}><b>Remove</b></FlatButton>
            <Dialog
                shown={shown}
                setShown={onClose}
                wrapperProps={{style: {width: REMOVE_ENTITLEMENT_TOOL_MODAL_WIDTH}}}>
                <RemoveEntitlementToolModal
                    selectedRecords={selectedRecords}
                    onChange={onChange}
                    onClose={onClose}
                />
            </Dialog>
        </>
    );
};
